module.exports = __webpack_public_path__ + "img/mar_created.251a3257.png";